exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/landing_page/src/app/components/login-popup/login-popup.component.scss
// module id = ../../../../../src/app/components/login-popup/login-popup.component.scss
// module chunks = main